import { render } from "./AddCreancePage.vue?vue&type=template&id=553c6423&ts=true"
import script from "./AddCreancePage.vue?vue&type=script&lang=ts"
export * from "./AddCreancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__